import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeftIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15.833 10L4.16634 10",
		stroke: "#9298B4",
		strokeWidth: 1.66667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10 15.833L4.16667 9.99967L10 4.16634",
		stroke: "#9298B4",
		strokeWidth: 1.66667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgArrowLeftIcon;
